import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'codici-utente',
    initialState: {
        codici_utente: [],
        statusAction: 'READY',
    },
    actions: ['GET_CODICI_UTENTE'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.GET_CODICI_UTENTE_SUCCESS:
                return {
                    ...state,
                    codici_utente: action.payload.codici_utente
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getCodiciUtenteRequest: () => ({ type: types.GET_CODICI_UTENTE_REQUEST }),
        getCodiciUtenteSuccess: ({ codici_utente }) => ({
            type: types.GET_CODICI_UTENTE_SUCCESS,
            payload: { codici_utente },
        }),
        getCodiciUtenteFailed: error => ({ type: types.GET_CODICI_UTENTE_FAILED, error: true, payload: { error } }),
    }),
});
